import React from "react"
// import PropTypes from "prop-types"
import { Box } from "@chakra-ui/react"

const Video = ({ autoplay, url, alt, title }) => {

    return (
        <Box id="videoBox" padding={0} marginLeft={'10px'} marginRight={'10px'}>
            {autoplay ?
                <Box id="video" as="video" autoPlay loop muted playsInline margin={0}  >
                    <source src={url} type="video/mp4" alt={alt} title={title} />
                    Video not supported
                </Box>
                :
                <Box id="video" as="video" muted >
                    <source src={url} type="video/mp4" alt={alt} title={title} />
                    Video not supported
                </Box>
            }
        </Box>
    )
}


// Video.propTypes = {
//     url: PropTypes.string.isRequired,
//     autoplay: PropTypes.bool,
//     className: PropTypes.string.isRequired,
//     alt: PropTypes.string.isRequired,
//     title: PropTypes.string.isRequired,
// }

// Video.defaultProps = {
//     autoplay: false
// }

export default Video
